import React from 'react';
import classnames from 'classnames';
import { Bubble, BubbleProps } from 'tea-component';
import NP_PERMISSION from '@gp/assets/svg/no-permission.svg';
import './index.scss';
import { NO_PERMISSION_TIPS } from '@gp/constants/noPermissionTips';
interface RestrictedContentProps extends BubbleProps {
  className?: string;
}

// 宽表无权限显示内容
const RestrictedContent: React.FC<RestrictedContentProps> = (props) => {
  const { className } = props;

  return (
    <Bubble
      className={classnames('dbg-bubble-max-width dbg-bubble-aline-blue', className, {
        'dbg-pipeline-project-list-first-time-change-bubble': false,
      })}
      placement={'top'}
      content={NO_PERMISSION_TIPS}
    >
      <div className="dbg-restricted-content-div">
        <div className="dbg-restricted-content-icon">
          <img className="dbg-restricted-content-icon-img" src={NP_PERMISSION} alt="" />
        </div>
        <div className="dbg-restricted-content-text">
          <span className="dbg-restricted-content-text-label">{'Restricted content'}</span>
        </div>
      </div>
    </Bubble>
  );
};

export default RestrictedContent;
